<template>
    <div class="bg-white shadow p-2 flex rounded transition flex-wrap flex-col fixed right-0 w-1/4 top-0 min-h-screen z-max"
        :style="{transform: expanded ? 'translateX(0)' : 'translateX(100%)'}">
        <div class="transition px-4">
            <div class="flex items-center">
                <h1 class="mt-4 text-lg mb-4">Filter projektov</h1>
                <button @click="closePanel" class="ml-auto py-2 px-3 rounded-full overflow-hidden w-10 h-10 flex items-center justify-content" v-ripple>
                    <font-awesome icon="arrow-right"></font-awesome>
                </button>
            </div>
            <div class="flex flex-wrap items-center -mx-4">
                <div class="w-full px-4 py-6">
                    <md-field md-clearable @md-clear="decideWhatDo">
                        <label>Hľadať podľa názvu</label>
                        <md-input v-model="searching" @keyup="keyupLoad" />
                    </md-field>
                </div>
                <div class="w-full px-4">
                    <multiselect v-model="members"
                                 :options="users"
                                 :selected="extractedMembers"
                                 deselect-label="Can't remove this value"
                                 :searchable="false"
                                 :close-on-select="true"
                                 :multiple="true"
                                 :show-labels="false"
                                 :hideSelected="true"
                                 track-by="id" label="name"
                                 @keyup="keyupLoad"
                                 placeholder="Podľa členov projektu">
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.name }} ({{
                            option.type.name }})
                        </template>
                        
                        <template slot="tag" slot-scope="{ option, remove }">
                            <div class="multiselect__tag" v-ripple>
                                <img v-if="option.image" :src="'/uploads/'+option.image"
                                     class="w-6 h-6 rounded-full mr-3">
                                <span v-if="!option.image" :class="'bg-'+option.color"
                                      class="inicial-box flex items-center justify-center mr-3 text-xs w-6 h-6 text-white rounded-full">{{ getInicials(option) }}</span>
                                <span class="text-sm">{{ option.name }}</span>
                                <span class="multiselect__tag-icon">
                                        <i class="material-icons" @click="remove(option)">close</i>
                                    </span>
                            </div>
                        </template>
                        
                        <template slot="option" slot-scope="{ option }">
                                <span class="flex items-center">
                                    <img v-if="option.image" :src="'/uploads/'+option.image"
                                         class="w-6 h-6 rounded-full mr-3">
                                    <span v-if="!option.image" :class="'bg-'+option.color"
                                          class="inicial-box flex items-center justify-center mr-3 text-xs w-6 h-6 text-white rounded-full">{{ getInicials(option) }}</span>
                                    <span class="text-sm">{{ option.name }} ({{ option.type.name }})</span>
                                </span>
                        </template>
                    </multiselect>
                </div>
                <div class="absolute bottom-0 left-0 right-0 w-full py-4 px-6">
                    <button class="text-orange-500 uppercase text-sm py-1 px-3"
                            @click="loadNewData"
                            v-ripple>Aplikovať</button>
                    <button :class="{'text-gray-300': !filterEnabled}"
                            :disabled="!filterEnabled"
                            class="text-black uppercase text-sm py-1 px-3"
                            @click="cancelFilter"
                            v-ripple>Zrušiť filter</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {getInicials, serialize} from "../../utils";

    export default {
        name: "ProjectListFilter",

        props: {
            fetch: {
                type: Function,
                required: true
            },
            data: {
                type: Function,
                required: true
            },
            expanded: {
                type: Boolean,
                default: false
            },
            closeCallback: {
                type: Function,
                default: () => {}
            }
        },

        data() {
            return {
                searching: '',
                members: [],
                extractedMembers: []
            }
        },

        computed: {
            ...mapState({
                users: state => state.users.all,
                filterEnabled: state => state.filter.enabled
            })
        },

        mounted() {
            this.$store.dispatch("fetchUsers");
        },

        methods: {
            decideWhatDo() {
                if(this.members.length > 0) {
                    this.loadNewData();
                }else {
                    this.cancelFilter();
                }
            },
            keyupLoad(e) {
                if(e.keyCode === 13) {
                    this.loadNewData();
                }
            },
            getInicials(user) {
                return getInicials(user.name, user.image);
            },
            expandFilter() {
                this.expanded = !this.expanded;
            },
            
            closePanel() {
                setTimeout(() => {
                    this.closeCallback();
                }, 200);
            },
            
            cancelFilter() {
                let data = Object.assign({}, this.data());
                this.fetch(data.page);
                this.$store.commit("setFilter", false);
                this.members = [];
                this.closePanel();
            },

            loadNewData() {
                let mems = [];
                let data = Object.assign({}, this.data());
                
                if(this.members.length === 0 && this.searching.length === 0) {
                    this.cancelFilter();
                    return;
                }

                for (let member of this.members) {
                    mems.push(member.id);
                }

                data.search = this.searching;
                data.members = mems;
                data.page = 1;
                this.$store.commit("setProjectsPage", data.page);
                this.$store.commit("setFilter", true);

                this.fetch(data.page, data);
                this.closePanel();
            }
        },
    }
</script>

<style scoped>

</style>